import type { ReactElement } from 'react';
import { COMPANY_FACTS, type CompanyFact } from '@/shared/config';

/** 사업자 정보에서 한 칸을 이름으로 꺼낸다 — 값의 단일 원천은 shared/config/company.ts 다. */
const factOf = (label: string): CompanyFact | undefined =>
  COMPANY_FACTS.find((fact) => fact.label === label);

/**
 * 견적문의 고객센터 — 흑연 판에 전화·운영시간·메일. 디자인 없이 상담이 필요한 경우의 길이다
 * (디자인 없는 견적 요청 화면은 범위 밖, 견적 설계 §17).
 */
export const QuoteGuideContact = (): ReactElement => {
  const phone = factOf('전화번호');
  const hours = factOf('상담 운영시간');
  const email = factOf('E-Mail');

  return (
    <section
      aria-labelledby="quote-contact-heading"
      className="flex flex-col gap-10 bg-primary px-6 py-12 text-white sm:px-12 sm:py-16 lg:flex-row lg:items-end lg:justify-between"
    >
      <div className="flex flex-col gap-4">
        <span aria-hidden className="block h-1 w-12 bg-brand-lime" />
        <h2
          id="quote-contact-heading"
          className="text-[clamp(1.75rem,3.4vw,3rem)] leading-[1.2] font-bold tracking-[-0.03em]"
        >
          고객센터
        </h2>
        <p className="text-[15px] text-white/70 sm:text-base">
          디자인 없이 상담이 필요하면 고객센터로 연락 주세요.
        </p>
      </div>

      <dl className="grid gap-6 sm:grid-cols-[auto_auto] sm:gap-x-12">
        {phone === undefined ? null : (
          <div className="flex flex-col gap-1 sm:col-span-2">
            <dt className="text-[11px] font-semibold tracking-[0.18em] text-white/60 uppercase">
              Tel
            </dt>
            <dd className="text-[clamp(1.75rem,3vw,2.5rem)] leading-none font-bold tracking-[-0.02em] tabular-nums">
              <a href={phone.href} className="hover:text-brand-lime">
                {phone.value}
              </a>
            </dd>
          </div>
        )}
        {hours === undefined ? null : (
          <div className="flex flex-col gap-1">
            <dt className="text-[11px] font-semibold tracking-[0.18em] text-white/60 uppercase">
              Hours
            </dt>
            <dd className="text-[15px]">{hours.value}</dd>
          </div>
        )}
        {email === undefined ? null : (
          <div className="flex flex-col gap-1">
            <dt className="text-[11px] font-semibold tracking-[0.18em] text-white/60 uppercase">
              E-mail
            </dt>
            <dd className="text-[15px]">
              <a href={email.href} className="underline underline-offset-4 hover:text-brand-lime">
                {email.value}
              </a>
            </dd>
          </div>
        )}
      </dl>
    </section>
  );
};
